<div class="observations-card">
  <div class="grid no-padding">
    <div class="row">
      <div class="col no-padding" size="12">
        <p class="observations-card__info__title">
          {{ 'MANAGE_VACATIONS.INDIVIDUAL_OBSERVATIONS' | translate }}
        </p>
        <p>
          {{ 'MANAGE_VACATIONS.INDIVIDUAL_OBSERVATIONS_TEXT' | translate }}
        </p>
        <app-input-wrapper>
          <app-richtext-editor
            [class.disabled]="!canEdit"
            [showActions]="false"
            [placeholder]="'MANAGE_VACATIONS.OBSERVATIONS_PLACEHOLDER' | translate"
            [(ngModel)]="content"
            (ngModelChange)="onObservationsChange()"
            [emojiPickerEnabled]="false"
            [disabled]="!canEdit">
          </app-richtext-editor>
        </app-input-wrapper>

        <footer *ngIf="canEdit">
          <button
            class="c-button secondary"
            [disabled]="disableDelete"
            onclick="this.blur()"
            (click)="onActionClicked(false)">
            {{ 'DELETE' | translate }}
          </button>
          <button
            class="c-button primary"
            [disabled]="disableSend"
            onclick="this.blur()"
            (click)="onActionClicked(true)">
            {{ 'SEND' | translate }}
          </button>
        </footer>
      </div>
    </div>
  </div>
</div>
